import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog9 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1f2078da-e6d4-4c0a-e777-2245cdb4f600/public" //Init_Blog9.webp
                alt="Img"
                loading="lazy"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <h1
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                <span className="font-semibold">
                  The Rise of FinTech + Logistics{" "}
                  <br className="hidden md:block" /> Tech: How AI is Powering
                  India’s <br className="hidden md:block" />
                  Shipping & Wallet Systems
                </span>
              </h1>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            Fintech and logistics in India are combining in previously
            unheard-of ways. Businesses are achieving unprecedented levels of
            efficiency and transparency with AI-powered shipping platforms and
            wallet systems. This collaboration is establishing new standards for
            international e-commerce in 2025.
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p className="font-bold">AI Applications in FinTech & Logistics</p>

            <p>
              • Wallet-Based Payments: AI-powered cashback analytics, safe
              transactions, and instant recharges.
            </p>

            <p>
              • Fraud Prevention: Real-time payment fraud prevention through
              machine learning models that identify irregularities.
            </p>

            <p>
              • Smart Shipping Routes: AI guarantees quicker shipments, lowers
              fuel expenses, and optimises delivery routes.
            </p>

            <p>
              • Dynamic Pricing Models: AI-driven shipping and payment prices
              that change in real time according to availability and demand.
            </p>

            <p>
              • Integrated Platforms: Enhanced user experience through unified
              dashboards where payments and logistics collide.
            </p>
          </div>

          <div className="space-y-3">
            <p className="font-bold">Impact on Businesses</p>

            <p>1. Faster cash flow with real-time wallet integration</p>

            <p>2. Better inventory management with predictive analytics</p>

            <p>
              3. Higher customer satisfaction with accurate delivery timelines
            </p>
          </div>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <p>
            In India's digital economy, the combination of fintech and
            AI-powered logistics is not merely a fad but a revolution. Companies
            that adopt it will be at the forefront of customer trust and
            efficiency.
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>October 07, 2025 ∙ 5 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog9;
